/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material/styles";
import { Dialog } from "@mui/material";

export const SuccessDialog = styled(Dialog)({
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(15, 23, 42, 0.45)",
  },
  "& .MuiDialog-paper": {
    width: "min(460px, calc(100vw - 32px))",
    maxWidth: "460px",
    borderRadius: "12px",
    backgroundImage: "none",
  },
});
